module.exports = __webpack_public_path__ + "img/Solklar_logo.00902de0.png";